/* eslint-disable import/no-anonymous-default-export */
import { useContext } from "react";
import { useParams } from "react-router-dom";
import MainLayout from "../../common/components/MainLayout";
import InfraccionesBrowser from "../../infracciones/components/InfraccionesBrowser";
import VerificacionViewer from "../components/VerificacionViewer";
import useInfraccionesRadarAPI from "../../infracciones/hooks/useInfraccionesAPI";
import useEstadisticasAPI from "../../estadisticas/useEstadisticasAPI";
import UsuariosContext from '../../common/contexts/UsuariosContext';

export default () => {
    const api = useInfraccionesRadarAPI();
    const { lote } = useParams();
    const estadisticasApi = useEstadisticasAPI();
    const usuariosContext = useContext(UsuariosContext);

    return (
        <MainLayout maxContentWidth={90}>

            <div style={{ marginTop: "1rem" }} >
                <InfraccionesBrowser
                    getItemStatusColor={(index, page, infraccion) => {
                        if (infraccion.Estado == 'DESCARTADA') {

                            return '#e53935';
                        }
                        else if (infraccion.Estado == 'CONSULTADA') {
                            return 'white';
                        }
                        else {

                            return '#43a047';
                        }
                    }}
                    title={`Verificación de infracciones - Lote ${lote}`}
                    limit={50}
                    list={(top, skip, filter) => api.getQueriedInfraciones({ $top: top, $skip: skip, $filter: [...[`LoteConsulta/NroLote eq ${lote}`], ...filter], $expand: ["OverlaysImagenes", "EtiquetasImagenes($expand=Etiqueta)", "CodigoInfraccion", "Equipo($expand=ConfiguracionProduccion)", "Imagenes", "ImagenPatente", "Titular", "LoteConsulta", "Videos"] })}
                    groupBy={(query, type) => api.getQueriedInfracionesGroup(query, type, lote)}
                    breadcrumbUrl={`/verificacion/${lote}`}
                    findById={(id) => api.getQueriedInfraciones({ $filter: [`Id eq ${id}`], $expand: ["OverlaysImagenes", "EtiquetasImagenes($expand=Etiqueta)", "CodigoInfraccion", "Equipo($expand=ConfiguracionProduccion)", "Imagenes", "ImagenPatente", "Titular", "LoteConsulta", "Videos"] })}
                    getProgressQuantity={(data) => `${data.cantidadInfraccionesVerificadas} verificada/s`}
                    getProgress={(data) => data.cantidadInfraccionesVerificadas + data.cantidadInfraccionesDescartadas > 0 ? parseFloat((((data.cantidadInfraccionesVerificadas + data.cantidadInfraccionesDescartadas) / data.cantidadInfracciones) * 100).toFixed(2)) : 0}
                    todayStatisticsText={"Verificadas hoy (lote)"}
                    yesterdayStatisticsText={"Verificadas ayer (lote)"}
                    statisticsProcess={'VERIFICACION'}
                    getMonthStatistics={(month: number) => estadisticasApi
                        .getEstadisticasInfracciones({
                            $filter: [
                                `year(FechaVerificacion) eq ${(new Date()).getFullYear()}`,
                                `month(FechaVerificacion) eq ${month}`,
                                "Estado in ('VERIFICADA','EXPORTADA','ACTA_GENERADA','IMPRESION_GENERADA','DESCARTADA')",
                                `LoteConsultaId eq ${lote}`
                            ]
                        }, 'MES', 'FechaVerificacion')
                    }
                    statusFilters={[
                        {
                            label: "Descartadas",
                            groupFilter: "CantidadInfraccionesDescartadas ge 1",
                            infractionFilter: "Estado eq 'DESCARTADA'"
                        },
                        {
                            label: "Verificadas",
                            groupFilter: "CantidadInfraccionesVerificadas ge 1",
                            infractionFilter: "Estado eq 'VERIFICADA'"
                        },
                        {
                            label: "Procesadas por el usuario actual",
                            groupFilter: "",
                            infractionFilter: `VerificadorId eq ${usuariosContext.user?.id}`
                        }
                    ]}
                >
                    <VerificacionViewer />
                </InfraccionesBrowser>
            </div>
        </MainLayout>


    );
};